export let containers: Container[] = [
  {
    id: 1,
    name: "Miniaturní panák",
    type: "Panák",
    volume: 20,
    units: "ml",
    icon: "shot.svg",
    iconSizeMultiplier: 0.3,
  },
  {
    id: 2,
    name: "Malinkatej panák",
    type: "Panák",
    volume: 25,
    units: "ml",
    icon: "shot.svg",
    iconSizeMultiplier: 0.4,
  },
  {
    id: 3,
    name: "Malej panák",
    type: "Panák",
    volume: 30,
    units: "ml",
    icon: "shot.svg",
    iconSizeMultiplier: 0.5,
  },
  {
    id: 4,
    name: "Takovej menší panák",
    type: "Panák",
    volume: 35,
    units: "ml",
    icon: "shot.svg",
    iconSizeMultiplier: 0.6,
  },
  {
    id: 5,
    name: "Velkej panák",
    type: "Panák",
    volume: 40,
    units: "ml",
    icon: "shot.svg",
    iconSizeMultiplier: 0.8,
  },
  {
    id: 6,
    name: "Gigantickej panák",
    type: "Panák",
    volume: 50,
    units: "ml",
    icon: "shot.svg",
    iconSizeMultiplier: 1,
  },
  {
    id: 10,
    name: "Malá sklenice",
    type: "Sklenice",
    volume: 250,
    units: "ml",
    icon: "wine-glass.svg",
    iconSizeMultiplier: 0.4,
  },
  {
    id: 11,
    name: "Střední sklenice",
    type: "Sklenice",
    volume: 350,
    units: "ml",
    icon: "wine-glass.svg",
    iconSizeMultiplier: 0.7,
  },
  {
    id: 12,
    name: "Velká sklenice",
    type: "Sklenice",
    volume: 450,
    units: "ml",
    icon: "wine-glass.svg",
    iconSizeMultiplier: 1,
  },
  {
    id: 15,
    name: "Pullitr",
    type: "Sklenice",
    volume: 500,
    units: "ml",
    icon: "beer.svg",
    iconSizeMultiplier: 1,
  },
  {
    id: 16,
    name: "Láhev 250ml",
    type: "Láhev",
    volume: 250,
    units: "ml",
    icon: "vodka.svg",
    iconSizeMultiplier: 0.3,
  },
  {
    id: 17,
    name: "Láhev 330ml",
    type: "Láhev",
    volume: 350,
    units: "ml",
    icon: "vodka.svg",
    iconSizeMultiplier: 0.4,
  },
  {
    id: 18,
    name: "Láhev 500ml",
    type: "Láhev",
    volume: 500,
    units: "ml",
    icon: "vodka.svg",
    iconSizeMultiplier: 0.5,
  },
  {
    id: 19,
    name: "Láhev 700ml",
    type: "Láhev",
    volume: 700,
    units: "ml",
    icon: "vodka.svg",
    iconSizeMultiplier: 0.7,
  },
  {
    id: 20,
    name: "Láhev 1000ml",
    type: "Láhev",
    volume: 1000,
    units: "ml",
    icon: "vodka.svg",
    iconSizeMultiplier: 1,
  },
];

export type Drink = {
  id?: number | string;
  name: string;
  alcoholVolume: number;
  icon?: string;
  defaultContainerId?: number;
  type: string;
  ownDrink?: boolean;
};

export type Container = {
  id?: number;
  name?: string;
  volume: number;
  units: string;
  type: string;
  icon?: string;
  iconSizeMultiplier?: number;
  ownContainer?: boolean;
};
